import { filter } from 'lodash';
import { programOptions } from 'src/components/Cases/utils';
import {
  buildIdFallback,
  findBySelectedId,
} from './selectFieldHelpers';

export const getCaseTypeType = (values) => values?.case_type?.type || values?.case_type;

export const getFilteredProgrammingOptions = ({
  programmingOptionsArray,
  userCanReferOutOfNetwork,
  caseTypeType,
}) => (
  userCanReferOutOfNetwork && caseTypeType !== 'org_case' ?
    programmingOptionsArray :
    filter(programmingOptionsArray, (program) => program.attributes.default === false)
);

export const toProgramSelectOptions = (filteredProgrammingOptionsArray) => (
  programOptions(filteredProgrammingOptionsArray).map((program) => ({
    value: String(program.id),
    label: program.name,
  }))
);

export const buildProgramNextValue = (selectedId, programmingOptionsArray) => {
  const selectedProgram = selectedId ? findBySelectedId(programmingOptionsArray, selectedId) : null;
  return selectedProgram || buildIdFallback(selectedId);
};
